import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'menus_nav',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    themeColor: {
      type: String,
      default: '#c20c0c'
    },
    styleId: [Number, String]
  },
  data: function data() {
    return {
      currentIndex: 0,
      currentType: ''
    };
  },
  methods: {
    changeMenu: function changeMenu(index) {
      var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.currentIndex = index;
      this.currentType = item.type;
    }
  },
  computed: {
    menusList: function menusList() {
      return this.value.config.value || [];
    },
    childrenList: function childrenList() {
      var _this$menusList$this$;
      return ((_this$menusList$this$ = this.menusList[this.currentIndex]) === null || _this$menusList$this$ === void 0 ? void 0 : _this$menusList$this$.childrens) || [];
    }
  }
};